import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { showErrorMessages } from "helpers/helpers"

import { GET_ALL_PRODUCT_CATEGORIES } from "./actionTypes"
import { changePreloader } from "../../store/layout/actions"
import { getAllProductCategoriesCall } from "../../helpers/repository"
import { getAllProductCategoriesResponseSuccess } from "./actions"
function* attemptGetAllProductCategories() {
  try {
    yield put(changePreloader(true))
    const response = yield call(getAllProductCategoriesCall)
    yield put(
      getAllProductCategoriesResponseSuccess(
        response.data.data.product_categories
      )
    )
    yield put(changePreloader(false))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* ProductsCategoriesSaga() {
  yield takeEvery(GET_ALL_PRODUCT_CATEGORIES, attemptGetAllProductCategories)
}

export default ProductsCategoriesSaga
